var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        bgGradient: "",
        img: null,
        locations: _vm.locations,
        helpForm: false,
        location: _vm.user?.selected_location ?? null,
        title: _vm.showSuccess ? "Thanks!" : null,
        subtitle: _vm.showSuccess ? "We received your withdrawal" : null,
        breadcrumbs: ["Home", "Goodbye 🙁"],
      },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0",
          attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
        },
        [
          !_vm.showSuccess
            ? _c("ExitForm", {
                attrs: {
                  errors: _vm.errors,
                  user: _vm.user,
                  memberships: _vm.memberships,
                  whyExitOptions: _vm.whyExitOptions,
                },
                on: {
                  success: function ($event) {
                    _vm.showSuccess = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showSuccess
            ? _c(
                "div",
                {
                  staticClass:
                    "white--text text-h6 flex-col text-center mx-auto",
                  staticStyle: { "max-width": "400px" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(`The last day of your membership and billing cycle will be
            ${_vm.gracePeriod} (Because that’s 30 days from today), unless you
            picked a specific date after ${_vm.gracePeriod}.`) +
                      "\n            "
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    "\n            Any lessons after that date will be deleted. Your Community\n            Manager will process your withdrawal and you’ll receive an email\n            with your final invoice amount. You don’t need to do anything\n            else.\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }